import * as StytchReact from "@stytch/react";
import { processEnvServer } from "@RHCommerceDev/hooks/useSsrHooks";

const useStytch = () => {
  if (!processEnvServer) {
    return StytchReact.useStytch();
  }

  return null;
};

export default useStytch;
